// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2vXtQ","insightsList":"newBusinessInsightsMenu_insightsList__2tj5B","active":"newBusinessInsightsMenu_active__jIhsm"};